export function stripHtml(value = "") {
  return String(value)
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function truncateText(value = "", max = 180) {
  const clean = stripHtml(value);

  if (clean.length <= max) return clean;

  return `${clean.slice(0, max - 1)}…`;
}

export function formatDate(value) {
  if (!value) return "";

  const raw = String(value).trim();

  const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);

  if (!match) return "";

  const [, yyyy, mm, dd] = match;

  return `${dd}/${mm}/${yyyy}`;
}

export function formatDateTime(value) {
  if (!value) return "Date inconnue";

  const raw = String(value).trim();

  const match = raw.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2}))?/,
  );

  if (!match) return "Date inconnue";

  const [, yyyy, mm, dd, hh, mi] = match;

  if (!hh || !mi) {
    return `${dd}/${mm}/${yyyy}`;
  }

  return `${dd}/${mm}/${yyyy} à ${hh}:${mi}`;
}

export function getFullName(item) {
  return `${item?.prenom || ""} ${item?.nom || ""}`.trim();
}

export function normalizePhoneForTel(value = "") {
  return String(value || "").replace(/\s+/g, "");
}

export function isValidEmail(email = "") {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).trim());
}

export function normalizeTrombinoForm(form) {
  const serviceIdNum = parseInt(form.service_id, 10);

  return {
    nom: form.nom?.trim() || "",
    prenom: form.prenom?.trim() || "",
    fonction: form.fonction?.trim() || "",
    role_type: form.role_type?.trim() || "",
    groupe: form.groupe?.trim() || "",
    service_id: !Number.isNaN(serviceIdNum) ? serviceIdNum : null,
    mail_pro: form.mail_pro?.trim() || "",
    tel_pro: form.tel_pro?.trim() || "",
    photo_url: form.photo_url?.trim() || "",
    presentation_courte: form.presentation_courte || "",
    bio_html: form.bio_html || "",
    mandat_debut: form.mandat_debut || null,
    mandat_fin: form.mandat_fin || null,
    ordre_affichage: Number(form.ordre_affichage) || 0,
    is_elected: !!form.is_elected,
    is_visible: !!form.is_visible,
  };
}

export function validateTrombinoForm(form) {
  const errors = {};

  if (!form.nom?.trim()) {
    errors.nom = "Le nom est obligatoire.";
  }

  if (!form.prenom?.trim()) {
    errors.prenom = "Le prénom est obligatoire.";
  }

  if (!form.fonction?.trim()) {
    errors.fonction = "La fonction est obligatoire.";
  }

  if (form.mail_pro?.trim() && !isValidEmail(form.mail_pro)) {
    errors.mail_pro = "L’adresse email n’est pas valide.";
  }

  if (
    form.mandat_debut &&
    form.mandat_fin &&
    String(form.mandat_fin) < String(form.mandat_debut)
  ) {
    errors.mandat_fin = "La date de fin doit être postérieure à la date de début.";
  }

  return errors;
}

export function buildTrombinosSearchParams({
  q,
  electedFilter,
  visibleFilter,
  serviceFilter,
  page,
  limit,
}) {
  const params = {
    q: q?.trim() || undefined,
    page,
    limit,
    sort: "ordre",
    dir: "ASC",
  };

  if (electedFilter === "elected") {
    params.is_elected = true;
  } else if (electedFilter === "personnel") {
    params.is_elected = false;
  }

  if (visibleFilter === "visible") {
    params.is_visible = true;
  } else if (visibleFilter === "hidden") {
    params.is_visible = false;
  }

  if (serviceFilter !== "all" && serviceFilter !== "") {
    params.service_id = serviceFilter;
  }

  return params;
}

export function getTrombinosStats(items = [], total = 0) {
  const electedOnPage = items.filter((item) => !!item.is_elected).length;
  const personnelOnPage = items.filter((item) => !item.is_elected).length;
  const visibleOnPage = items.filter((item) => !!item.is_visible).length;
  const hiddenOnPage = items.filter((item) => !item.is_visible).length;
  const withPhotoOnPage = items.filter((item) => !!item.photo_url).length;
  const withContactOnPage = items.filter(
    (item) => !!item.mail_pro || !!item.tel_pro,
  ).length;
  const linkedToServiceOnPage = items.filter((item) => !!item.service_id).length;

  return {
    total,
    electedOnPage,
    personnelOnPage,
    visibleOnPage,
    hiddenOnPage,
    withPhotoOnPage,
    withContactOnPage,
    linkedToServiceOnPage,
  };
}

export function buildServiceOptionsFromRows(rows = []) {
  const map = new Map();

  rows.forEach((person) => {
    const service = person?.service;

    if (service?.id && !map.has(service.id)) {
      map.set(service.id, service.nom_service || `Service #${service.id}`);
    }
  });

  return Array.from(map.entries())
    .map(([id, label]) => ({ id, label }))
    .sort((a, b) => a.label.localeCompare(b.label, "fr"));
}